/**
 * Enviar's atmospheric background: two glow orbs (azure + violet wave)
 * soft and blurred, anchored behind the content. It uses the theme's
 * `--glow-*` tokens, so it adapts to light/dark without hardcoding. Purely
 * decorative and `pointer-events-none` — it never intercepts touches.
 */

import type { Component } from "solid-js";

export const PageBackground: Component = () => (
  <div
    aria-hidden="true"
    class="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-background"
  >
    <div
      class="absolute -top-32 -right-24 h-[42vh] w-[42vh] rounded-full blur-3xl"
      style={{ background: "radial-gradient(closest-side, var(--glow-0), transparent)" }}
    />
    <div
      class="absolute top-1/3 -left-32 h-[46vh] w-[46vh] rounded-full blur-3xl"
      style={{ background: "radial-gradient(closest-side, var(--glow-1), transparent)" }}
    />
    <div
      class="absolute -bottom-40 right-1/4 h-[40vh] w-[40vh] rounded-full blur-3xl"
      style={{ background: "radial-gradient(closest-side, var(--glow-2), transparent)" }}
    />
  </div>
);
